import {
  useLayoutEffect,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";
import Modal from "../Modal";
import {
  datesStrings,
  monthData,
  monthsNum,
  newMonthData,
} from "../../utils/data";
import ArrowButton from "../ArrowButton";
import PerformanceCalender from "../PerformanceCalender/PerformanceCalender";
import {
  calenderSetter,
  convertDateToObj,
  formatDateObj,
  getAsOfDate,
  getCalenderDate,
  getDateForCalender,
  getDatesObj,
  getEventDate,
  monthFullNameArr,
} from "../../utils/functions";
import UserStore from "../../store/UserStore";
import { observer } from "mobx-react";
import { useMemo } from "react";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import PerformanceStore from "../../store/PerformanceStore";
import Calender from "../Calender/Calender";
import ShowErrorModal from "../ModalFamily/ShowErrorModal";
//import dropdownIcon from "../../assets/images/svg/dropdownIcon.svg";

const DatePicker2 = ({
  open,
  setOpen,
  isActive,
  onClose,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  timePeriod,
  handleReset,
  initialToDate,
  initialFromDate,
  resetedFromDate,
  resetedToDate,
  minDate = UserStore?.forReportsInceptionDate,
  parentComp = "report",
  events = false,
  modalClass = "",
  setDatesWithCustomLogic = undefined,
  validateDate = undefined,
  validationMessage = "",
  buttonClass = "",
}) => {
  const [eventName, setEventName] = useState("");
  const [isStart, setisStart] = useState(true);
  const [asOfDateState, setAsOfDateState] = useState({
    date: "",
    month: "",
    year: "",
  });
  const [selectedFromDate, setSelectedFromDate] = useState({
    date: "",
    month: "",
    year: "",
  });
  const [selectedToDate, setSelectedToDate] = useState({
    date: "",
    month: "",
    year: "",
  });
  const [toSetCalFromDates, setToSetCalFromDates] = useState({
    startDay: "",
    prevMonthEndDate: "",
    thisMonthEndDate: "",
  });

  const [toSetCalToDates, setToSetCalToDates] = useState({
    startDay: "",
    prevMonthEndDate: "",
    thisMonthEndDate: "",
  });
  const [isResetClicked, setIsResetClicked] = useState(false);
  const [isEventOpen, setIsEventOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const eventRef = useRef();
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const fromDateWrapperRef = useRef(null);
  const toDateWrapperRef = useRef(null);

  const btnFromDate = getCalenderDate(fromDate);
  const btnToDate = getCalenderDate(toDate);

  const handleResetCalender = () => {
    setIsResetClicked(true);
    const filteredFromMonth = newMonthData?.[resetedFromDate.month];
    const filteredToMonth = newMonthData?.[resetedToDate.month];
    setSelectedFromDate({
      date: datesStrings?.[resetedFromDate.date],
      month: filteredFromMonth,
      year: resetedFromDate.year,
    });
    setSelectedToDate({
      date: datesStrings?.[resetedToDate.date],
      month: filteredToMonth,
      year: resetedToDate.year,
    });

    setEventName({
      eventName: "Event not selected",
      id: null,
    });
  };

  const setToDateToTodayForCalender = () => {
    const as_of_date = getAsOfDate(UserStore.asOfDate);
    const todaysDate = new Date(as_of_date);
    todaysDate.setDate(1);
    setToSetCalToDates({
      startDay: todaysDate.getDay(),
      prevMonthEndDate: new Date(
        todaysDate.getFullYear(),
        todaysDate.getMonth(),
        0,
      ).getDate(),
      thisMonthEndDate: new Date(
        todaysDate.getFullYear(),
        todaysDate.getMonth() + 1,
        0,
      ).getDate(),
    });
  };

  useLayoutEffect(() => {
    const oneYearDef = 31536000000;
    const as_of_date = getAsOfDate(UserStore.asOfDate);
    const dateObjofAsOfDate = new Date(as_of_date);
    const forCustomFirstDate = new Date(
      dateObjofAsOfDate.getTime() - oneYearDef,
    );
    if (isStart && timePeriod === "custom") {
      setisStart((prevState) => !prevState);
      setAsOfDateState({
        date: getDateForCalender(dateObjofAsOfDate.getDate()),
        month: monthData[dateObjofAsOfDate.getMonth()],
        year: dateObjofAsOfDate.getFullYear(),
      });
      if (fromDate && toDate) {
        const filteredFromMonth = newMonthData?.[fromDate?.month];
        const filteredToMonth = newMonthData?.[toDate?.month];
        setSelectedFromDate({
          date: datesStrings?.[fromDate?.date],
          month: filteredFromMonth,
          year: fromDate?.year,
        });
        setSelectedToDate({
          date: datesStrings?.[toDate?.date],
          month: filteredToMonth,
          year: toDate?.year,
        });
      }

      dateObjofAsOfDate.setDate(1);
      setToSetCalFromDates({
        startDay: forCustomFirstDate.getDay(),
        prevMonthEndDate: new Date(
          forCustomFirstDate.getFullYear(),
          forCustomFirstDate.getMonth(),
          0,
        ).getDate(),
        thisMonthEndDate: new Date(
          forCustomFirstDate.getFullYear(),
          forCustomFirstDate.getMonth() + 1,
          0,
        ).getDate(),
      });
      setToDateToTodayForCalender();
    } else {
    }
    // eslint-disable-next-line
  }, [timePeriod]);

  const setDates = ({ fromDate, toDate }) => {
    if (fromDate && toDate) {
      const filteredFromMonth = newMonthData?.[fromDate?.month];
      const filteredToMonth = newMonthData?.[toDate?.month];
      setSelectedFromDate({
        date: datesStrings?.[fromDate?.date],
        month: filteredFromMonth,
        year: fromDate?.year,
      });
      setSelectedToDate({
        date: datesStrings?.[toDate?.date],
        month: filteredToMonth,
        year: toDate?.year,
      });

      const { month, year } = fromDate;
      const { month: toMonth, year: toYear } = toDate;
      const newFromDate = new Date(`${year}-${month}-01`);
      const newToDate = new Date(`${toYear}-${toMonth}-01`);
      setToSetCalFromDates({
        startDay: newFromDate.getDay(),
        prevMonthEndDate: new Date(
          newFromDate.getFullYear(),
          newFromDate.getMonth(),
          0,
        ).getDate(),
        thisMonthEndDate: new Date(
          newFromDate.getFullYear(),
          newFromDate.getMonth() + 1,
          0,
        ).getDate(),
      });
      setToSetCalToDates({
        startDay: newToDate.getDay(),
        prevMonthEndDate: new Date(
          newToDate.getFullYear(),
          newToDate.getMonth(),
          0,
        ).getDate(),
        thisMonthEndDate: new Date(
          newToDate.getFullYear(),
          newToDate.getMonth() + 1,
          0,
        ).getDate(),
      });
    }
  };

  useEffect(() => {
    if (open) {
      setIsResetClicked(false);
      setDates({ fromDate, toDate });
    }
    // eslint-disable-next-line
  }, [open]);

  const handleClose = () => {
    function setCalenderDate() {
      setFromDate({
        date:
          selectedFromDate?.date < 10
            ? `0${selectedFromDate?.date}`?.replaceAll("00", "0")
            : selectedFromDate?.date,
        year: selectedFromDate.year,
        month: monthsNum[monthData.indexOf(selectedFromDate?.month)],
      });
      setToDate({
        date:
          selectedToDate?.date < 10
            ? `0${selectedToDate?.date}`?.replaceAll("00", "0")
            : selectedToDate?.date,
        year: selectedToDate.year,
        month: monthsNum[monthData.indexOf(selectedToDate?.month)],
      });
      onClose({
        isDateChanged: true,
        eventName: eventName?.eventName
          ? eventName
          : PerformanceStore.selectedEvent,
      });
    }
    if (isResetClicked) {
      handleReset();
    }
    if (!validateDate) {
      setCalenderDate();
    } else {
      const isValidationSuccessful = validateDate({
        fromDate: selectedFromDate,
        toDate: selectedToDate,
      });
      if (isValidationSuccessful) {
        setCalenderDate();
      } else {
        setIsErrorModalOpen(true);
      }
    }
  };

  const ChangeCalederDates = (
    changedDate,
    compareWithDate,
    DateType,
    forFromLimitDate,
    minDate,
  ) => {
    const setFromCalender = (date, arr) => {
      setSelectedFromDate(convertDateToObj(date, true));
      const finalDate = new Date(date);
      if (fromDateRef.current) {
        fromDateRef.current.setPreSelection(finalDate);
      }
      setToSetCalFromDates(getDatesObj(arr));
    };
    const setToCalender = (date, arr) => {
      setSelectedToDate(convertDateToObj(date, true));
      const finalDate = new Date(date);
      if (toDateRef.current) {
        toDateRef.current.setPreSelection(finalDate);
      }
      setToSetCalToDates(getDatesObj(arr));
    };

    if (!setDatesWithCustomLogic) {
      calenderSetter(
        changedDate,
        compareWithDate,
        forFromLimitDate,
        minDate,
        selectedFromDate,
        DateType,
        setFromCalender,
        setToCalender,
      );
    } else {
      setDatesWithCustomLogic(
        changedDate,
        compareWithDate,
        forFromLimitDate,
        minDate,
        selectedFromDate,
        DateType,
        setFromCalender,
        setToCalender,
      );
    }

    setEventName({
      eventName: "Event not selected",
      id: null,
    });
  };

  useEffect(() => {
    if (PerformanceStore.eventsApiStatus === "success") {
      setIsLoading(false);
    }
  }, [PerformanceStore.eventsApiStatus]);

  const onClickOutside = useCallback((menu) => {
    switch (menu) {
      case "event":
        setIsEventOpen(false);
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (eventRef.current && !eventRef.current.contains(event.target)) {
        onClickOutside && onClickOutside("event");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    if (open) {
      setEventName("");
    }
  }, [open]);

  const DatePickerModalContent = useMemo(() => {
    return (
      <>
        {events && (
          <div className="event_wrapper">
            <div id="calender_cont">
              <div className="event_container">
                <div className="event_desc">Event name :</div>
                <div
                  ref={eventRef}
                  className={
                    !isEventOpen
                      ? "month_dropdown_wrapper perf_tabs"
                      : "month_dropdown_wrapper perf_tabs activated"
                  }
                >
                  <button
                    className="link cursor"
                    onClick={() => {
                      if (!PerformanceStore.eventsData.length) {
                        setIsLoading(true);
                        PerformanceStore.getEvents(
                          (data) => {},
                          (err) => {},
                        );
                      }

                      setIsEventOpen(!isEventOpen);
                    }}
                  >
                    <span>
                      {" "}
                      {eventName.eventName ||
                        PerformanceStore.selectedEvent?.eventName}
                    </span>{" "}
                    <img
                      src={downArrowBlack}
                      //src={btnDownArrow}
                      alt="arrow"
                    />
                  </button>{" "}
                  <div className="month_content event" tabIndex={0}>
                    {isLoading ? (
                      <button className="button is-loading" disabled>
                        Loading
                      </button>
                    ) : PerformanceStore.eventsData.length ? (
                      PerformanceStore.eventsData?.map((data) => (
                        <button
                          style={{
                            fontFamily: "Encode Sans",
                            cursor: "pointer",
                          }}
                          key={data}
                          onClick={() => {
                            setEventName(data);

                            setDates({
                              fromDate: getEventDate(data.fromDate),
                              toDate: getEventDate(data.toDate),
                            });
                            setIsEventOpen(false);
                          }}
                          className={""}
                          tabIndex={0}
                        >
                          {data.eventName}
                        </button>
                      ))
                    ) : (
                      "No events found"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <p className="datepicker_heading">Time Period</p>
        <div className="date_show_container">
          <div>
            <h2>From Date</h2>
            <h3>
              {`${
                selectedFromDate?.date < 10
                  ? `0${selectedFromDate?.date}`?.replaceAll("00", "0")
                  : selectedFromDate?.date
              } ${
                selectedFromDate?.month
                  ? selectedFromDate?.month.slice(0, 3)
                  : selectedFromDate?.month
              } ${selectedFromDate?.year} `}
            </h3>
          </div>
          <div>
            <h2>To Date</h2>
            <h3>
              {`${
                selectedToDate?.date < 10
                  ? `0${selectedToDate?.date}`?.replaceAll("00", "0")
                  : selectedToDate?.date
              } ${
                selectedToDate?.month
                  ? selectedToDate?.month.slice(0, 3)
                  : selectedToDate?.month
              } ${selectedToDate?.year} `}
            </h3>
          </div>
        </div>

        {false && (
          <div
            className="calender_container"
            style={{ height: "0px", minHeight: "0px" }}
          >
            <div>
              <PerformanceCalender
                type={"from"}
                selectedDate={selectedFromDate}
                toSetCalDates={toSetCalFromDates}
                dateLimit={
                  toSetCalFromDates.thisMonthEndDate +
                    toSetCalFromDates.startDay >
                  35
                    ? 42
                    : 35
                }
                changeCalenderDates={(
                  changedDate,
                  compareWithDate,
                  DateType,
                  limitDate,
                  minDate,
                ) =>
                  ChangeCalederDates(
                    changedDate,
                    compareWithDate,
                    DateType,
                    limitDate,
                    minDate,
                  )
                }
                limitDate={
                  String(asOfDateState.year) +
                  "-" +
                  `${
                    monthFullNameArr.indexOf(asOfDateState.month) < 10
                      ? "0" + monthFullNameArr.indexOf(asOfDateState.month)
                      : monthFullNameArr.indexOf(asOfDateState.month)
                  }` +
                  "-" +
                  String(
                    `${
                      asOfDateState.date < 10 &&
                      asOfDateState.date?.length === 1
                        ? "0" + asOfDateState.date
                        : asOfDateState.date
                    }`,
                  )
                }
                limitMonth={`${
                  monthData.indexOf(asOfDateState.month) < 10
                    ? "0" + monthData.indexOf(asOfDateState.month)
                    : monthData.indexOf(asOfDateState.month)
                }`}
                limitYear={asOfDateState.year}
                minDate={minDate}
                imitDateForTo={
                  String(selectedToDate.year) +
                  "-" +
                  `${
                    monthFullNameArr.indexOf(selectedToDate.month) < 10
                      ? "0" + monthFullNameArr.indexOf(selectedToDate.month)
                      : monthFullNameArr.indexOf(selectedToDate.month)
                  }` +
                  "-" +
                  String(
                    `${
                      selectedToDate.date < 10 &&
                      selectedToDate.date?.length === 1
                        ? "0" + selectedToDate.date
                        : selectedToDate.date
                    }`,
                  )
                }
              />
            </div>
            <div>
              <PerformanceCalender
                type={"to"}
                selectedDate={selectedToDate}
                toSetCalDates={toSetCalToDates}
                dateLimit={
                  toSetCalToDates.thisMonthEndDate + toSetCalToDates.startDay >
                  35
                    ? 42
                    : 35
                }
                changeCalenderDates={(
                  changedDate,
                  compareWithDate,
                  DateType,
                  limitDate,
                  minDate,
                ) =>
                  ChangeCalederDates(
                    changedDate,
                    compareWithDate,
                    DateType,
                    limitDate,
                    minDate,
                  )
                }
                limitDate={
                  String(asOfDateState.year) +
                  "-" +
                  `${
                    monthFullNameArr.indexOf(asOfDateState.month) < 10
                      ? "0" + monthFullNameArr.indexOf(asOfDateState.month)
                      : monthFullNameArr.indexOf(asOfDateState.month)
                  }` +
                  "-" +
                  String(
                    `${
                      asOfDateState.date < 10 &&
                      asOfDateState.date?.length === 1
                        ? "0" + asOfDateState.date
                        : asOfDateState.date
                    }`,
                  )
                }
                limitMonth={`${
                  monthData.indexOf(asOfDateState.month) < 10
                    ? "0" + monthData.indexOf(asOfDateState.month)
                    : monthData.indexOf(asOfDateState.month)
                }`}
                limitYear={asOfDateState.year}
                minDate={minDate}
              />
            </div>
          </div>
        )}
        <div className="calender_container">
          <div>
            <Calender
              type={"from"}
              selectedDate={selectedFromDate}
              toSetCalDates={toSetCalFromDates}
              dateLimit={
                toSetCalFromDates.thisMonthEndDate +
                  toSetCalFromDates.startDay >
                35
                  ? 42
                  : 35
              }
              changeCalenderDates={(
                changedDate,
                compareWithDate,
                DateType,
                limitDate,
                minDate,
              ) =>
                ChangeCalederDates(
                  changedDate,
                  compareWithDate,
                  DateType,
                  limitDate,
                  minDate,
                )
              }
              limitDate={
                String(asOfDateState.year) +
                "-" +
                `${
                  monthFullNameArr.indexOf(asOfDateState.month) < 10
                    ? "0" + monthFullNameArr.indexOf(asOfDateState.month)
                    : monthFullNameArr.indexOf(asOfDateState.month)
                }` +
                "-" +
                String(
                  `${
                    asOfDateState.date < 10 && asOfDateState.date?.length === 1
                      ? "0" + asOfDateState.date
                      : asOfDateState.date
                  }`,
                )
              }
              limitMonth={`${
                monthData.indexOf(asOfDateState.month) < 10
                  ? "0" + monthData.indexOf(asOfDateState.month)
                  : monthData.indexOf(asOfDateState.month)
              }`}
              limitYear={asOfDateState.year}
              minDate={minDate}
              imitDateForTo={
                String(selectedToDate.year) +
                "-" +
                `${
                  monthFullNameArr.indexOf(selectedToDate.month) < 10
                    ? "0" + monthFullNameArr.indexOf(selectedToDate.month)
                    : monthFullNameArr.indexOf(selectedToDate.month)
                }` +
                "-" +
                String(
                  `${
                    selectedToDate.date < 10 &&
                    selectedToDate.date?.length === 1
                      ? "0" + selectedToDate.date
                      : selectedToDate.date
                  }`,
                )
              }
              ref={fromDateRef}
              containerRef={fromDateWrapperRef}
            />
          </div>
          <div>
            <Calender
              type={"to"}
              selectedDate={selectedToDate}
              toSetCalDates={toSetCalToDates}
              dateLimit={
                toSetCalToDates.thisMonthEndDate + toSetCalToDates.startDay > 35
                  ? 42
                  : 35
              }
              changeCalenderDates={(
                changedDate,
                compareWithDate,
                DateType,
                limitDate,
                minDate,
              ) =>
                ChangeCalederDates(
                  changedDate,
                  compareWithDate,
                  DateType,
                  limitDate,
                  minDate,
                )
              }
              limitDate={
                String(asOfDateState.year) +
                "-" +
                `${
                  monthFullNameArr.indexOf(asOfDateState.month) < 10
                    ? "0" + monthFullNameArr.indexOf(asOfDateState.month)
                    : monthFullNameArr.indexOf(asOfDateState.month)
                }` +
                "-" +
                String(
                  `${
                    asOfDateState.date < 10 && asOfDateState.date?.length === 1
                      ? "0" + asOfDateState.date
                      : asOfDateState.date
                  }`,
                )
              }
              limitMonth={`${
                monthData.indexOf(asOfDateState.month) < 10
                  ? "0" + monthData.indexOf(asOfDateState.month)
                  : monthData.indexOf(asOfDateState.month)
              }`}
              limitYear={asOfDateState.year}
              minDate={minDate}
              ref={toDateRef}
              containerRef={toDateWrapperRef}
            />
          </div>
        </div>
        <div className="footer_reset_apply_wrapper">
          <button onClick={handleResetCalender}>
            <p className="reset_text">Reset</p>
          </button>

          <ArrowButton type="next" label="Apply" onClick={handleClose} />
        </div>
      </>
    );
  }, [
    selectedFromDate,
    selectedToDate,
    isEventOpen,
    isLoading,
    PerformanceStore.eventsApiStatus,
    eventName,
  ]);

  return (
    <>
      <button
        onClick={() => {
          setOpen(true);
          fromDateRef.current.setPreSelection(
            new Date(formatDateObj(selectedFromDate)),
          );
          toDateRef.current.setPreSelection(
            new Date(formatDateObj(selectedToDate)),
          );
        }}
        className={`time_period_date_picker ${
          parentComp === "tabs" ? "performance_tabs" : ""
        } ${isActive ? "active" : ""} ${buttonClass}`}
        aria-haspopup="dialog"
        aria-label={`Date picker from ${btnFromDate} to ${btnToDate}`}
        disabled={!isActive}
      >
        <div className="date_wrapper">
          <p className="date_text">From Date</p>
          <p className="date_format">{btnFromDate}</p>
          {isActive && (
            <div className="down_arrow">
              <DownArrow />
            </div>
          )}
        </div>
        <div className="date_wrapper">
          <p className="date_text">To Date</p>
          <p className="date_format">{btnToDate}</p>
          {isActive && (
            <div className="down_arrow">
              <DownArrow />
            </div>
          )}
        </div>
      </button>
      <Modal
        onClose={onClose}
        open={open}
        width="789px"
        minWidth="789px"
        title=""
        showCloseIcon={true}
        modalContainerClass={`datepicker_modal_container ${modalClass}`}
        modalId={"date-picker-modal"}
      >
        {DatePickerModalContent}
      </Modal>
      <Modal
        modalStyle={{
          padding: "25px 25px 33px",
        }}
        onClose={() => setIsErrorModalOpen(false)}
        open={isErrorModalOpen}
        showCloseIcon={true}
      >
        {" "}
        <ShowErrorModal
          msg={validationMessage}
          onConfirm={() => setIsErrorModalOpen(false)}
          buttonClassName={"date-picker-date-error"}
        />
      </Modal>
    </>
  );
};

export default observer(DatePicker2);
